import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";


export interface ColumnOption {
  value: string;
  label: string;
}

interface ColumnVisibilityFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
  options: ColumnOption[];
  labelId?: string;
  size?: "small" | "medium";
  minWidth?: number;
}

const MENU_PROPS = {
  PaperProps: {
    sx: {
      maxHeight: 250,
      overflowY: "auto",
    },
  },
  MenuListProps: { dense: true, autoFocusItem: false },
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
} as const;

const ColumnVisibilityFilter = ({
  value,
  onChange,
  options,
  labelId = "columns-select-label",
  size = "medium",
  minWidth = 220,
}: ColumnVisibilityFilterProps) => {
  const handleChange = (event: SelectChangeEvent<typeof value>) => {
    const { value: v } = event.target;
    const next = typeof v === "string" ? (v.split(",") as string[]) : (v as string[]);
    onChange(next);
  };

  return (
    <FormControl sx={{ minWidth }} size={size}
    >
      <Select<string[]>
        labelId={labelId}
        multiple
        value={value}
        onChange={handleChange}
        renderValue={(selected) => (
          <span style={{ fontWeight: 600 }}>{`${(selected as string[]).length} column(s) visible`}</span>
        )}
        size={size}
        MenuProps={MENU_PROPS}
      >
        {options.map((opt) => (
          <MenuItem
            key={opt.value}
            value={opt.value}
            sx={{
              py: 0.5,
              "&.Mui-selected": {
                backgroundColor: "transparent",
              },
              "&.Mui-selected:hover": {
                backgroundColor: "action.hover",
              },
              "&.Mui-focusVisible.Mui-selected": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Checkbox checked={value.includes(opt.value)} />
            <ListItemText primary={opt.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ColumnVisibilityFilter;
